import { useCallback, useEffect, useState } from 'react'

import css from './sass/liveauction.module.scss'
import themeCss from '../../components/sass/theme.module.scss'
import { handleEscapeKey } from 'sites/auctions/components/utils'

import { formatMoney } from 'services/util'
import { getUserPurchases } from '../auctionsadminutil'

export default function UserFullHistoryTable( {auctionDetail, user} ) {

  const {UserId: userId, FullName: fullName} = user
  const [showInfo, setShowInfo] = useState(false)
  const [userPurchases, setUserPurchases] = useState()
  const [userDonations, setUserDonations] = useState()

  const bids = auctionDetail.Bids
  //individual item bids sorted with most recent on top
  const userBids = bids?.filter(bid=> (bid.UserId === userId))
  .sort((a,b) => a.Timestamp < b.Timestamp ? 1 : -1)


  useEffect(() => {
    setUserPurchases(getUserPurchases(userId, auctionDetail))
  }, [auctionDetail, userId])

  useEffect(() => {
    const userReg = auctionDetail?.Registrations?.find((ele) => ele.User.UserId === userId)
    setUserDonations(userReg?.DonationTotal)
  }, [auctionDetail, userId])

  const itemMap = {}
  auctionDetail.Items.forEach((item) => {
    itemMap[item.ItemId] = {Title: item.Title, CurrentBid: item.CurrentBid}
  })

  const click = () => {
    let current = showInfo
    setShowInfo(!current)
  }

  const toggleModal = useCallback(() => {
      setShowInfo(false)
    }, [setShowInfo])
  
  useEffect(() => {
    const onKeyDown = (event) => handleEscapeKey(event, toggleModal)
    //add event listener for when modal is mounted
    document.addEventListener('keydown', onKeyDown)
    //clean up when modal is unmounted
    return () => document.removeEventListener('keydown', onKeyDown)

  }, [toggleModal])

  return (
    <div>
      <button className={css['admin-info-modal-link']} onClick={()=>click()} >{fullName}</button>
      
      {showInfo && (<>
        <div className={themeCss['modal-background']} onClick={()=>click()}></div>
        <div className={themeCss['modal-card']}>
          <button className={`${themeCss['button']} ${themeCss['FilledBlue']} ${themeCss['centered-button']}`} onClick={()=>click()} >Close Modal</button>
          
          {auctionDetail?.Items && auctionDetail.Items.length > 0 &&
            <>
              <h4 className={css['admin-info-modal-header']}>Bid History for {fullName}</h4>
              {userBids.length !== 0 ?
                <table className={themeCss['data-table']}>
                  <thead>
                    <tr>
                      <th>Item Title</th>
                      <th>Bid Amount</th>
                      <th>Bid Time</th>
                    </tr>
                  </thead>
                  <tbody>
                  {userBids && userBids.map((bid) => {
                      return (
                        <tr key={bid.Timestamp}>
                          <td>{itemMap[bid.ItemId].Title}</td>
                          <td>${formatMoney(bid.BidAmount)} {bid.BidAmount === itemMap[bid.ItemId].CurrentBid ? '🏆' : ''}</td>
                          <td>{new Date(bid.Timestamp).toLocaleString()}</td>
                        </tr>)
                    })}
                  </tbody>
                </table>
              :
              <p> {fullName} has not bid on any items in this auction yet.</p>}
            </>
          }

          {auctionDetail?.FixedItems && auctionDetail.FixedItems.length > 0 &&
            <>
              <h4 className={css['admin-info-modal-header']}>Purchase History for {fullName}</h4>
              {userPurchases.length !== 0 ?
                <table className={themeCss['data-table']}>
                  <thead>
                    <tr>
                      <th>Item Title</th>
                      <th>Purchase Quantity</th>
                      <th>Amount Owed</th>
                    </tr>
                  </thead>
                  <tbody>
                  {userPurchases && userPurchases.map((purchase) => {
                      return (
                        <tr key={purchase.Title}>
                          <td>{purchase.Title}</td>
                          <td>{formatMoney(purchase.Quantity)}</td>
                          <td>${formatMoney(purchase?.AmountOwed)}</td>
                          
                        </tr>)
                    })}
                  </tbody>
                </table>
              :
              <p> {fullName} has not purchased any buy it now items in this auction yet.</p>}
            </>
          }

          {auctionDetail?.HasDonation &&
            <>
              <h4 className={css['admin-info-modal-header']}>Donation Total for {fullName}</h4>
              {userDonations > 0 ? 
                <p> {fullName} has donated <b>${formatMoney(userDonations)}</b> to this auction's fund.</p>
                :
                <p> {fullName} has not donated to this auction's fund yet.</p>}
            </>
          }

        </div>
      </>)}
    </div>    
  )
}
